module.exports = __webpack_public_path__ + "media/img/support/contacts-d9bf82b79502a849e090ebda48e92b60.jpg";